module.exports = __webpack_public_path__ + "static/media/activate_sound_icon.fa8f7a89.svg";